import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReturnResult } from '../models/return-result';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {
  baseUrl: string = environment.apiTimezoneManagement;

  constructor(private http: HttpClient) { }

  getTimezone(): Observable<ReturnResult<any>> {
    return this.http.get<ReturnResult<any>>(`${this.baseUrl}/GetSystemTimezone`);
  }

  convertToSystemTimezone(clientTimezone?: string): Observable<ReturnResult<string>> {
    var tz = clientTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    var offset = -new Date().getTimezoneOffset();
    return this.http.post<ReturnResult<any>>(`${this.baseUrl}/ConvertToSystemTimezone`, {
      timezone: tz,
      offset: 0
    });
  }

  convertToClientTimezone(systemTimezone: string): Observable<ReturnResult<string>> {
    return this.http.post<ReturnResult<any>>(`${this.baseUrl}/ConvertToClientTimezone`, {
      timezone: systemTimezone,
      offset: 0
    });
  }

  getServerTimezone(): Observable<ReturnResult<any>> {
    return this.http.get<ReturnResult<any>>(`${this.baseUrl}/GetServerTimezone`);
  }
}
